import { getAccountName } from 'constants/integrations';
import {
  EventMessage,
  EventType,
  SyncJobEventType,
  DocumentProcessingEventType,
  WebSocketContext,
} from 'contexts/WebSocketContext';
import { FeatureFlag } from 'featureFlags';
import { useObservable } from 'observable-hooks';
import { getAppServices } from 'providers/app-services';
import { useContext } from 'react';
import { Observable } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';

export type ToastEvent = {
  type: 'success' | 'info' | 'error';
  body: `${string}:${string}`;
  title: `${string}:${string}`;
  translationVariables: Record<string, string | number>;
};

const mapEventToToastEvent = (event: EventMessage): ToastEvent | null => {
  const { featureFlagService } = getAppServices();

  if (
    event.type === EventType.DocumentProcessingEvent &&
    featureFlagService.hasFeature(FeatureFlag.TilingNotification)
  )
    if (event.event === DocumentProcessingEventType.MapTilingCompleted) {
      return {
        body: 'toastText:mapTilingCompleted.message',
        title: 'toastText:mapTilingCompleted.title',
        type: 'info',
        translationVariables: {},
      };
    }

  if (
    event.type === EventType.FileEvent &&
    (event.event === SyncJobEventType.PendingUpload ||
      event.event === SyncJobEventType.UploadComplete ||
      event.event === SyncJobEventType.UploadError)
  ) {
    const providerName = getAccountName(event.payload.provider);
    console.log(event.payload);
    if (event.event === SyncJobEventType.PendingUpload)
      return {
        body: 'toastText:filePendingUploadProvider.message',
        title: 'toastText:filePendingUploadProvider.title',
        type: 'info',
        translationVariables: { providerName },
      };

    if (event.event === SyncJobEventType.UploadComplete)
      return {
        body: 'toastText:fileUploadCompleteProvider.message',
        title: 'toastText:fileUploadCompleteProvider.title',
        type: 'success',
        translationVariables: { providerName },
      };

    if (event.event === SyncJobEventType.UploadError)
      return {
        body: 'toastText:fileUploadErrorProvider.message',
        title: 'toastText:fileUploadErrorProvider.title',
        type: 'error',
        translationVariables: { providerName },
      };
  }

  return null;
};

const filterNull = <T>(event: T | null | undefined): event is T =>
  Boolean(event);

const useDriveSourceTargetEvents = (): Observable<ToastEvent> => {
  const { receive } = useContext(WebSocketContext);

  return useObservable(
    (state$: Observable<[Observable<EventMessage>]>) =>
      state$.pipe(
        mergeMap(([rcv]) => rcv),
        map(mapEventToToastEvent),
        filter(filterNull)
      ),
    [receive()]
  );
};

export default useDriveSourceTargetEvents;
